import { Table } from 'react-dsgov';
import styles from './vendaNacionalDetalhes.module.scss';
import { formatCurrency } from '../../../../../../../../../../utils/formatCurrency';
import {
  IOperacaoVendaNacionalResumo,
  IOperacaoVendaNacionalResumoItem,
  IOutrosRegimesTributo,
} from '../../../../../../../../../../interfaces/IOperacoes';

interface IHeader {
  field: string;
  label: string;
  format?: Function;
  value?: string | Function;
}

interface IFooter {
  value: string | JSX.Element | JSX.Element[];
  colspan?: number;
  show?: boolean;
}

interface IProps {
  data: IOperacaoVendaNacionalResumo;
}

function VendaNacionalDetalhes({ data }: IProps) {
  const TABELA_CABECALHO: IHeader[] = [
    {
      field: 'codigoNCM',
      label: 'Código NCM',
    },
    {
      field: 'receitaBrutaVenda',
      label: 'Receita Bruta de Venda(R$)',
      format: formatCurrency,
    },

    {
      field: 'quantidade',
      label: 'Quantidade',
      format: formataQuantidade,
    },
    {
      field: 'unidadeMedida',
      label: 'Unidade de Medida',
    },
    { field: 'precoUtilizado', label: 'Preço Médio (R$)', value: formatarPrecoMedio },
    { field: 'tributosValores', label: 'Deduções(R$)', value: formatarTributos },
    { field: 'baseCalculo', label: 'Base de Cálculo(R$)', format: formatCurrency },
    {
      field: 'isRejeito',
      label: 'Rejeitos/Estéreis',
      format: formataBoolean,
    },
    {
      field: 'hasUsoEspecifico',
      label: 'Uso Específico',
      format: formataBoolean,
    },
  ];

  const TABELA_RODAPE: IFooter[] = [
    { value: <span>Total (R$)</span> },
    { value: formatCurrency(data.valorTotalOperacao) },
    { value: formataQuantidade(data.quantidadeTotal) },
    { value: '', colspan: 2 },
    { value: colunaDeducoes(data.valorTotalTributosValores, data.valorTotalDeducoes, data.valorTotalTerceiro) },
    { value: formatCurrency(data.valorTotalBaseCalculo) },
    { value: '', colspan: 2 },
  ];

  function formataBoolean(valor: boolean) {
    return valor ? 'Sim' : 'Não';
  }

  function formataQuantidade(valor: number) {
    return valor.toLocaleString('pt-br');
  }

  function formatarPrecoMedio(item: IOperacaoVendaNacionalResumoItem) {
    return (
      <div>
        <span>{formatCurrency(item.receitaBrutaVenda / item.quantidade)}</span>
      </div>
    );
  }

  function formatarTributos(item: IOperacaoVendaNacionalResumoItem) {
    const tributos = item.tributosValores;
    return colunaDeducoes(tributos, item.totalDeducoes ?? 0, item.valorAquisicaoTerceiros ?? 0);
  }

  function colunaDeducoes(tributos: IOutrosRegimesTributo[], valorTotalTributos: number, valorTotalTerceiros: number) {
    let content: JSX.Element[] = [];

    tributos.forEach((item: IOutrosRegimesTributo) => {
      content.push(
        <div className={styles.deducoes} key={item.id}>
          <span>{item.nome}:</span> {formatCurrency(item.valor)}
        </div>
      );
    });
    content.push(
      <>
        <div className={styles.deducoes} key={'divValorComprasterceiro'}>
          <span>Compras de Terceiro:</span> {formatCurrency(valorTotalTerceiros)}
        </div>
        <div className={styles.deducoes} key={'divValorTotalTributos'}>
          <span>Total:</span> {formatCurrency(valorTotalTributos)}
        </div>
      </>
    );

    return content;
  }

  return (
    <div className={styles.secao}>
      <div className={styles.tabela}>
        <Table
          showTopBar={false}
          headers={TABELA_CABECALHO}
          showPagination={false}
          showDensityButtons={false}
          showSearch={false}
          density='medium'
          tabIndex={0}
        >
          <tbody>
            {data && data.listaNcm && data.listaNcm.length > 0 ? (
              data.listaNcm.map((item: any) => (
                <tr key={item.codigoNCM} data-testid='linha-dados'>
                  {TABELA_CABECALHO.map((header) => (
                    <>
                      <td key={header.field} className={styles.tableCell}>
                        {typeof header.value === 'function' && header.value(item)}

                        {header.format && header.format(item[header.field])}

                        {header.value == null && header.format == null && item[header.field]}
                      </td>
                    </>
                  ))}
                </tr>
              ))
            ) : (
              <tr data-testid='sem-operacao'>
                {' '}
                <th className={`border-right`} rowSpan={1} scope='rowgroup'></th>
                <td colSpan={5} className={styles.noOperacoes}>
                  Não há operações cadastradas
                </td>
              </tr>
            )}
          </tbody>

          <tfoot>
            <tr data-testid='linha-rodape'>
              {TABELA_RODAPE.map((footer, index) => (
                <td key={index} colSpan={footer.colspan ?? 1}>
                  {footer.show ?? footer.value}
                </td>
              ))}
            </tr>
          </tfoot>
        </Table>
      </div>
    </div>
  );
}

export default VendaNacionalDetalhes;
